import { ReactElement } from 'react';

import GlobalStates from '@/components/home/GlobalStates'; // FIXME
import { RoutesContext } from '@/contexts/RoutesCtx';
import { MessagesContext } from '@/contexts/MessagesCtx';
import { ReportContext } from '@/contexts/ReportCtx';
import { StreamChatAccess } from '@/components/stream-chat/StreamChatAccess';
import { TachographContext } from '@/contexts/TachographCtx';
import { SearchContext } from '@/contexts/SearchContext';
import { TargetAttributesContext } from '@/contexts/TargetAttributesContext';
import Popups from '@/components/home/Popups';

export default function Contexts({ children }: { children: ReactElement }) {
  return (
    <GlobalStates>
      <RoutesContext>
        <Popups>
          <MessagesContext>
            <ReportContext>
              <TachographContext>
                <SearchContext>
                  <TargetAttributesContext>
                    <StreamChatAccess>{children}</StreamChatAccess>
                  </TargetAttributesContext>
                </SearchContext>
              </TachographContext>
            </ReportContext>
          </MessagesContext>
        </Popups>
      </RoutesContext>
    </GlobalStates>
  );
}
